import { userConstants } from "../constants/userConstants";
import { userService } from "../../services/API/userService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";

export const accessActions = {};

export const userList = (formData, url) => {
  return dispatch => {
    userService.userList(formData, url).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: userConstants.LIST_SUPERADMIN_REQUEST, data };
  }
  function success(data) {
    return { type: userConstants.LIST_SUPERADMIN_SUCCESS, data };
  }
  function failure(error) {
    return { type: userConstants.LIST_SUPERADMIN_FAILURE, error };
  }
};

export const userStatus = (formData, url) => {
  return dispatch => {
    userService.userStatus(formData, url).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: userConstants.USER_STATUS_REQUEST, data };
  }
  function success(data) {
    return { type: userConstants.USER_STATUS_SUCCESS, data };
  }
  function failure(error) {
    return { type: userConstants.USER_STATUS_FAILURE, error };
  }
};

export const userDelete = (url) => {
  return dispatch => {
    userService.userDelete(url).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: userConstants.USER_STATUS_REQUEST, data };
  }
  function success(data) {
    return { type: userConstants.USER_STATUS_SUCCESS, data };
  }
  function failure(error) {
    return { type: userConstants.USER_STATUS_FAILURE, error };
  }
};


export const userDetail = (url) => {
  return dispatch => {
    userService.userDelete(url).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: userConstants.GET_USER_REQUEST, data };
  }
  function success(data) {
    return { type: userConstants.GET_USER_SUCCESS, data };
  }
  function failure(error) {
    return { type: userConstants.GET_USER_FAILURE, error };
  }
};

export const createUser = (formData, url, method) => {
  return dispatch => {
    userService.createUser(formData, url, method).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: userConstants.POST_DATA_REQUEST, data };
  }
  function success(data) {
    return { type: userConstants.POST_DATA_SUCCESS, data };
  }
  function failure(error) {
    return { type: userConstants.POST_DATA_FAILURE, error };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/actions/accessAction.js